import { ReactNode } from "react"
import './SlideContentWrapper.scss';

interface SildeContentHeaderProps {
    children: ReactNode
}

export default function SildeContentHeader({ children }: Readonly<SildeContentHeaderProps>) {
    return (
        <div className="slide-content-container">
            {children}
        </div>
    )
}